import React from "react";
import { Button, Icon } from "discover.medical.react-component-library";

const FeedbackButton = ({ clickHandler, isMobile }) => {
  return (
    <Button
      variant="secondary"
      size={"sm"}
      data-auto="feedback-button"
      data-testid="feedback-button"
      id="feedback_button"
      onClick={clickHandler}
    >
      <Icon icon={{ glyph: "comment", size: "sm" }} />
      {isMobile ? <></> : <span>Feedback</span>}
    </Button>
  );
};

FeedbackButton.displayName = "FeedbackButton";

export default FeedbackButton;
